import React, { useId } from "react";
import styles from "./Field.module.scss";

/**
 * Field — TEK form-alanı sarmalayıcısı (merkezi, SOLID). Sahip baz tasarım çizgisi:
 * sol ikon + küçük muted label + BORDERSIZ control (çerçeveyi satır sağlar).
 * Takvim, inspector, tüm modaller/formlar AYNI bunu kullanır → tek input sistemi.
 *
 *   <Field icon={<Calendar/>} label="Tarih" hint="..."><input .../></Field>
 *
 * variant="boxed" → control kutu içinde (search/select gibi affordance gerekenler).
 */
const Field = ({ icon, label, hint, error, required, children, action, alignTop, variant }) => {
  const id = useId();
  const childWithId = React.isValidElement(children)
    ? React.cloneElement(children, { id: children.props.id || id })
    : children;

  return (
    <div className={`${styles.field} ${alignTop ? styles.alignTop : ""} ${variant ? styles[variant] || "" : ""}`.trim()}>
      {icon ? <span className={styles.icon} aria-hidden>{icon}</span> : null}
      <div className={styles.content}>
        {label ? (
          <label htmlFor={id} className={styles.label}>
            {label}
            {required ? <span className={styles.required} aria-hidden>*</span> : null}
          </label>
        ) : null}
        <div className={styles.control}>
          {childWithId}
          {action ? <span className={styles.action}>{action}</span> : null}
        </div>
        {hint && !error ? <span className={styles.hint}>{hint}</span> : null}
        {error ? <span className={styles.error}>{error}</span> : null}
      </div>
    </div>
  );
};

export default Field;
